import { Directive, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[gogisPreventDefaultHref]',
  standalone: false,
})
export class InhertLinkDirective {
  @Input() href: string;

  @HostListener('click', ['$event'])
  noop(event: MouseEvent): void {
    if (this.href.length === 0 || this.href === '#') {
      event.preventDefault();
    }
  }
}
